(function () {
  function waitForSwiper(callback) {
    if (typeof Swiper === 'function') {
      callback();
      return;
    }

    window.addEventListener('load', function onLoad() {
      window.removeEventListener('load', onLoad);
      if (typeof Swiper === 'function') callback();
    });
  }

  function initSlider(root) {
    if (!root || root.swiper) return;

    root.swiper = new Swiper(root, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      resistanceRatio: 0.65,
      speed: 450,
      observer: true,
      observeParents: true,
    });
  }

  function destroySlider(root) {
    if (!root || !root.swiper) return;
    root.swiper.destroy(true, true);
    root.swiper = null;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lp-nightshift-reviews-slider]').forEach(initSlider);
  }

  function boot() {
    waitForSwiper(function () {
      initAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    waitForSwiper(function () {
      initAll(event.target);
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    (event.target || document).querySelectorAll('[data-lp-nightshift-reviews-slider]').forEach(destroySlider);
  });
})();
